<template>
    <v-parallax
      dark
      cover
      src="/img/earth-1756274_1280.webp"
    >
      <v-row align="center" justify="center">
        <v-col class="text-center" cols="12">
          <h1 class="text-h2 font-weight-bold mb-4">SPACESYNC</h1>
          <h2 class="text-h2 subheading">
            The world first blockchain based space platform
          </h2>
          <!-- Powered by <i class="cf cf-xlm"></i> -->
        </v-col>
      </v-row>
    </v-parallax>
</template>

<script>
export default {
  name: "HeadingComponent",
};
</script>

<style>
</style>